import React from 'react';
import { Select, MenuItem, SelectChangeEvent, FormControl, InputLabel } from '@mui/material';
import { ALL_EVENTS_GROUP } from '../../constants';
import { useUser } from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

interface SelectSidebarProps {
  eventGroups: any[];
  setSelectedEventGroup: (group: any) => void;
  selectedEventGroup: any;
}

const SelectSidebar: React.FC<SelectSidebarProps> = ({ eventGroups, setSelectedEventGroup, selectedEventGroup }) => {
  const { user, selectedChild, setSelectedChild } = useUser();
  const navigate = useNavigate();

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    if (!event.target.value) return;
    const selectedGroup = JSON.parse(event.target.value);
    setSelectedEventGroup(selectedGroup);
  };

  const handleChildSelectChange = (event: SelectChangeEvent<string>) => {
    const childId = event.target.value;
    if (!user || !user.children || !setSelectedChild) return;

    const child = user.children.find((c: any) => String(c.id) === String(childId));
    if (!child) return;

    setSelectedChild(child);

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('group_id');
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  return (
    <div className="basis-2/12 mb-5">
      <FormControl fullWidth>
        <InputLabel id="groups-select-label">Groups</InputLabel>
        <Select
          labelId="groups-select-label"
          id="groups-select"
          label="Groups"
          className="sidebar"
          value={selectedEventGroup ? JSON.stringify(selectedEventGroup) : ''}
          onChange={handleSelectChange}
          sx={{ width: '100%' }}
        >
          <MenuItem value="">Select Event Group</MenuItem>
          <MenuItem
            key={ALL_EVENTS_GROUP.id}
            value={JSON.stringify(ALL_EVENTS_GROUP)}
          >
            {ALL_EVENTS_GROUP.name}
          </MenuItem>
          {eventGroups.map((group: any) => (
            <MenuItem key={group.id} value={JSON.stringify(group)}>
              {group.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {user && user.children && user.children.length > 0 && (
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="children-select-label">Children</InputLabel>
          <Select
            labelId="children-select-label"
            id="children-select"
            label="Children"
            value={selectedChild ? String(selectedChild.id) : ''}
            onChange={handleChildSelectChange}
            sx={{ width: '100%' }}
          >
            <MenuItem value="">Select Child</MenuItem>
            {[...user.children]
              .sort((a, b) => new Date(a.dob).getTime() - new Date(b.dob).getTime())
              .map((child: any) => (
                <MenuItem key={child.id} value={String(child.id)}>
                  {child.fname} {child.lname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
    </div>
  );
};

export default SelectSidebar;
